module.exports = __webpack_public_path__ + "./welfare-outing_1808758d0befbf772cb8f3afcac00b07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionWork/2025/welfare-outing.jpg
// module id = 626
// module chunks = 0